<template>
<div>
    <v-card flat class="mt-7">
        <v-card-text>
            <v-tabs class="tabs-pill" v-model="tab">
                <v-tab>{{ $t("animal.all") + "(" + all + ")" }}</v-tab>
                <v-tab>{{ $t("animal.active") + "(" + grouped + ")" }}</v-tab>
                <v-tab>{{ $t("animal.ungrouped") + "(" + ungrouped + ")" }}</v-tab>
            </v-tabs>
        </v-card-text>
    </v-card>
    <v-card class="pa-4">
        <!-- <v-data-table 
            :headers="headers" 
            :items="items" 
            item-key="animalNumber" 
            v-model="selections" 
            :single-select="false" 
            :show-select="tab==2 || tab ==0"
            selectable-key="animalNumber" 
            :items-per-page="10" 
            :loading="loading" 
            :loading-text="$t('loadingPleaseWait')" 
            :options.sync="tableOptions" 
            :server-items-length="totalRecords" 
            :footer-props="{
                'items-per-page-options': itemsPerPageOptions,
                showFirstLastPage: true,
                'items-per-page-text': $t('geneticsAndBreeding.rowsPerPage'),
            }"
            :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal',
            }"
        > -->
        <v-data-table 
            :headers="headers" 
            :items="items" 
            item-key="animalNumber" 
            v-model="selections" 
            :single-select="false" 
            :show-select="tab ==0" 
            selectable-key="animalNumber" 
            :items-per-page="10" 
            :loading="loading" 
            :loading-text="$t('loadingPleaseWait')" 
            :options.sync="tableOptions" 
            :server-items-length="totalRecords" 
            :footer-props="{
                'items-per-page-options': itemsPerPageOptions,
                showFirstLastPage: true,
                'items-per-page-text': $t('geneticsAndBreeding.rowsPerPage'),
            }"
            :header-props="{
                'sort-icon': 'mdi-unfold-more-horizontal',
            }"
        >
            <template v-slot:top>
                <div class="d-flex mt-5">
                    <v-text-field prepend-inner-icon="mdi-magnify" outlined :placeholder="$t('geneticsAndBreeding.rowsPerPage')" dense style="max-width:25%" v-model="search" @input="searchEPD"></v-text-field>
                    <!-- <v-btn
                  :disabled="search.length < 1"
                  color="primary"
                  height="40"
                  width="40"
                  max-width="40"
                  outlined
                  class="ml-8"
                  @click="searchEPD"
                >
                  <v-icon>mdi-filter-outline</v-icon>
                </v-btn> -->
                    <v-spacer></v-spacer>
                    <!-- <v-btn v-if="tab==2 && selections.length > 0" color="primary" class="mr-4 bulk" depressed @click="epdBulkDeleteConfirm">BULK DELETE</v-btn> -->
                    <v-btn v-if="tab==0 && selections.length > 0" color="primary" class="mr-4 bulk" depressed @click="markBulkSubmitted">BULK SUBMIT</v-btn>
                    <div class="pt-2 px-2 black--text">
                        {{$t('geneticsAndBreeding.rowsPerPage')}}
                    </div>
                    <v-select style="max-width:63px;" v-model="tableOptions.itemsPerPage" dense :items="itemsPerPageOptions" class="mr-5"></v-select>
                    <div class="py-1 title">
                        {{ from }} - {{ to }} of {{ totalRecords }}
                    </div>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page <= 1" @click="pageChange(false)">
                        <v-icon dark> mdi-chevron-left </v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="tableOptions.page >= totalPages" @click="pageChange(true)">
                        <v-icon dark> mdi-chevron-right </v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" @click="$router.push({ name: 'GeneticsGrid' })">
                        <v-icon dark> mdi-view-grid-outline </v-icon>
                    </v-btn>
                    <!-- <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                >
                  <v-icon dark> mdi-format-list-bulleted </v-icon>
                </v-btn> -->
                </div>
            </template>
            <template v-slot:progress>
                <v-progress-linear color="primary" :height="8" indeterminate></v-progress-linear>
            </template>
            <template v-slot:item.animalNumber="{ item }">
                <span><a @click.prevent="
                $router.push({
                  name: 'SingleAnimalEpd',
                  params: { geneticid: item.animalNumber },
                })
              ">{{ item.animalNumber }}</a></span>
            </template>
            <template v-slot:item.name="{item}">
                <span class="text-left">{{ item.name }}</span>
            </template>
            <template v-slot:header.birthWeight="{}">
                <span class="">{{ weightUnit === 'lbs'
                    ? $t('geneticsAndBreeding.birthWeightLb')
                    : $t('geneticsAndBreeding.birthWeightKg') }}</span>
            </template>
            <template v-slot:item.birthWeight="{ item }">
                <span class="text-capitalize">{{
            !item.birthWeight || Number.isInteger(item.birthWeight)
              ? item.birthWeight || "-"
              : item.birthWeight.toFixed(2)
          }}</span>
            </template>
            <template v-slot:header.weaningWeight="{}">
                <span class="">{{ weightUnit === 'lbs'
                    ? $t('geneticsAndBreeding.weaningWeightLb')
                    : $t('geneticsAndBreeding.weaningWeightKg') }}</span>
            </template>
            <template v-slot:item.weaningWeight="{ item }">
                <span class="text-capitalize">{{
            !item.weaningWeight || Number.isInteger(item.weaningWeight)
              ? item.weaningWeight || "-"
              : item.weaningWeight.toFixed(2)
          }}</span>
            </template>
            <template v-slot:header.yearlingWeight="{}">
                <span class="">{{ weightUnit === 'lbs'
                    ? $t('geneticsAndBreeding.yearlingWeightLb')
                    : $t('geneticsAndBreeding.yearlingWeightKg') }}</span>
            </template>
            <template v-slot:item.yearlingWeight="{ item }">
                <span class="text-capitalize">{{
            !item.yearlingWeight || Number.isInteger(item.yearlingWeight)
              ? item.yearlingWeight || "-"
              : item.yearlingWeight.toFixed(2)
          }}</span>
            </template>
            <template v-slot:item.status="{ item }">
                <v-btn style="background: #E5F8F1;" color="#00BD73" outlined rounded>{{ item.status || "N/A" }}</v-btn>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn color="primary" icon @click="
                    $router.push({
                        name: 'EditGeneticsV2',
                        params: { geneticid: item.animalNumber },
                    })
                ">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="tab==2" color="red" icon @click="epdDeleteConfirm(item)"><v-icon>mdi-trash-can-outline</v-icon></v-btn>
            </template>
        </v-data-table>
    </v-card>
    <ConfirmBox
          :title="bulkConfirmElements.title"
          :message="bulkConfirmElements.message"
          :cancelBtnText="bulkConfirmElements.cancelBtnText"
          :confirmBtnText="bulkConfirmElements.confirmBtnText"
          :confirmData="bulkConfirmElements.confirmData"
          :dialog="bulkConfirm"
          @confirm:action="confirmBulkDelete"
        />
    <ConfirmBox
          :title="confirmElements.title"
          :message="confirmElements.message"
          :cancelBtnText="confirmElements.cancelBtnText"
          :confirmBtnText="confirmElements.confirmBtnText"
          :confirmData="confirmElements.confirmData"
          :dialog="confirm"
          @confirm:action="confirmDelete"
        />
</div>
</template>

<script>
import EPDService from "@/_services/EPDService";
import loadingMixin from "@/mixins/LoadingMixin";
import ConfirmBox from "@/components/ConfirmBox";
export default {
    components: {
        ConfirmBox,
    },
    mounted() {
        // if(this.$route.query.page){
        //   this.tableOptions.page = Number(this.$route.query.page)
        // }else{
        //   this.$router.replace(
        //     {query: { page: this.tableOptions.page}}
        //   )
        // }
        this.getEPDCounts();
        // this.getEPDData();
    },
    watch: {
        tab: {
            handler() {
                this.getEPDData();
            },
            deep: true,
        },
        tableOptions: {
            handler() {
              this.getEPDData();
            },
            deep: true,
        },
        "$route.query": {
            handler(v) {
                if (v?.page) {
                    this.tableOptions.page = Number(v.page);
                } 
                // else {
                //     this.$router.replace({
                //         query: {
                //             page: this.tableOptions.page
                //         }
                //     });
                // }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        weightUnit() {
            return (this.weightUnitt || "lbs").toLowerCase();
        }
    },
    data() {
        return {
            confirm: false,
            bulkConfirm: false,
            confirmElements: {
                title: "Remove Animal",
                message: "Are you sure you want to remove this Animal EPDs Information this will be permanently removed from the listing?",
                confirmBtnText: "Yes",
                cancelBtnText: "No",
                confirmData: {},
            },
            bulkConfirmElements: {
                title: "Delete Animals?",
                message: "",
                confirmBtnText: "Yes",
                cancelBtnText: "no",
                confirmData: {}
            },
            itemsPerPageOptions: [10, 25, 50, 100, 500],
            weightUnitt: "lbs",
            loading: false,
            search: "",
            selected: [],
            totalRecords: 1,
            totalPages: 0,
            to: 0,
            from: 0,
            tab: 0,
            tabs: ["all", "grouped", "ungrouped"],
            tableOptions: {},
            grouped: 0,
            ungrouped: 0,
            all: 0,
            items: [],
            headers: [{
                    text: this.$t("geneticsAndBreeding.animalID"),
                    value: "animalNumber",
                    class: "text-no-wrap black--text",
                    align: "start",
                    width: '200px'
                },
                {
                    text: this.$t("geneticsAndBreeding.animalName"),
                    value: "name",
                    class: "text-no-wrap black--text",
                    align: "start",
                    width: '100px'
                },
                {
                    text: this.$t("geneticsAndBreeding.tag"),
                    value: "tagNumber",
                    class: "text-no-wrap black--text",
                    align: "start",
                },
                {
                    text: this.$t("geneticsAndBreeding.gender"),
                    value: "gender",
                    class: "text-no-wrap black--text",
                    align: "start",
                },

                {
                    text: this.$t("geneticsAndBreeding.birthWeightLb"),
                    value: "birthWeight",
                    class: "black--text text-no-wrap px-0",
                    align: "start",
                },
                {
                    text: this.$t("geneticsAndBreeding.weaningWeightLb"),
                    value: "weaningWeight",
                    align: "start",
                    class: "black--text text-no-wrap px-0",
                },
                {
                    text: this.$t("geneticsAndBreeding.yearlingWeightLb"),
                    value: "yearlingWeight",
                    class: "black--text text-no-wrap px-0",
                    align: "start",
                },
                {
                    text: this.$t("geneticsAndBreeding.status"),
                    value: "status",
                    class: "black--text text-no-wrap",
                    align: "start",
                },
                {
                    text: this.$t(""),
                    value: "actions",
                    sortable: false,
                    align: "start",
                    class: "black--text text-no-wrap ",
                    width: "10%",
                },
            ],
            singleSelect: false,
            selections: []
        };
    },
    methods: {
        epdDeleteConfirm(epd) {
            this.confirmElements.confirmData = { epd };
            this.confirm = true;
        },
        confirmDelete(action, confirmData) {
            if (action) {
                this.startLoading();
                EPDService.deleteAnimalEpd(confirmData.epd.animalNumber)
                .then((res) => {
                    this.stopLoading();
                    this.confirm = false;
                    if (res.success) {
                        this.getEPDData()
                        this.getEPDCounts();
                        this.$notify({
                            title: "EPD data deleted.",
                            text: res.message,
                            type: "success",
                        });
                    } else {
                        this.$notify({
                            title: "Unable to update",
                            text: res.message,
                            type: "error",
                        });
                    }
                })
            .catch((err) => {
                console.log(err);
                this.stopLoading();
                this.confirm = false;
            });
            } else {
                this.confirm = false;
            }
        },
        epdBulkDeleteConfirm() {
            this.bulkConfirmElements.confirmData = { bulkConfirmData: this.selections.map(animal => animal.animalNumber) };
            this.bulkConfirmElements.message = `Are you sure you want to delete ${this.selections.length} Animals from the listing?\n\n By clicking on yes the animal will be removed permanentaly from the listing.`;
            this.bulkConfirm = true;
        },
        markBulkSubmitted() {
            const ids = this.selections.map(animal => animal.id)
            this.startLoading()
            EPDService.updateAnimalSubmitStatus(ids)
            .then((res) => {
              if (!res.success) throw res.message;
              this.getEPDCounts();
              this.selections = []
              this.$notify({
                title: "Record updated successfully.",
                text: res.message,
                type: "success",
              });
              this.stopLoading();
            })
            .catch((err) => {
              if (typeof err === "string" || err instanceof String) {
                this.errorMsg = err;
              } else {
                this.errorMsg =
                  err?.data?.message ||
                  "Something went wrong! Please try after sometime.";
              }
              this.stopLoading();
            });
            console.log(ids)
        },
        confirmBulkDelete(action, { bulkConfirmData }) {
            if (action) {
                this.startLoading();
                EPDService.deleteAnimalEpdBulk(bulkConfirmData)
                .then((res) => {
                    this.stopLoading();
                    if (res.success) {
                        this.getEPDData();
                        this.getEPDCounts();
                        this.$notify({
                            title: `${bulkConfirmData.length} records deleted!`,
                            text: res.message,
                            type: "success",
                        });
                    } else {
                        this.$notify({
                            title: "Unable to run bulk delete",
                            text: res.message,
                            type: "error",
                        });
                    }
                    this.bulkConfirm = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.stopLoading();
                    this.bulkConfirm = false;
                });
            } else {
                this.bulkConfirm = false;
            }
        },
        getEPDData() {
            this.loading = true;
            // this.tableOptions = {
            //     ...this.tableOptions,
            //     tab: this.tabs[this.tab]
            // };
            EPDService.getEPDList(this.tableOptions,this.tabs[this.tab], this.search)
                .then(res => {
                    this.items = res.data.rows;
                    this.weightUnitt = res.data.weightUnit;
                    this.totalRecords = res.data.count;
                    this.totalPages = Math.ceil(
                        this.totalRecords / this.tableOptions.itemsPerPage
                    );
                    this.from =
                        (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
                    this.to =
                        this.tableOptions.page * this.tableOptions.itemsPerPage -
                        (this.tableOptions.itemsPerPage - res.data.returnedRecords);
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    console.log("err", err);
                });
        },
        getEPDCounts() {
            this.loading = this.tableOptions = {
                ...this.tableOptions,
                tab: this.tabs[this.tab],
            };
            EPDService.getEPDCount()
                .then(res => {
                    this.all = res.data.all;
                    this.grouped = res.data.grouped;
                    this.ungrouped = res.data.ungroupped;
                    this.loading = false;
                })
                .catch(err => {
                    this.loading = false;
                    console.log("err", err);
                });
        },
        searchEPD() {
            this.items = [];
            this.tableOptions.page = 1;
            this.getEPDData();
        },

        resetSearchOnEmpty() {
            if (this.search !== "") return;
            this.tableOptions.page = 1;
            // this.getEPDData();
        },

        pageChange(t) {
            if (t) this.tableOptions.page = Number(this.tableOptions.page) + 1;
            else this.tableOptions.page = Number(this.tableOptions.page) - 1;

            // this.$router.replace(
            //   {query: { page: this.tableOptions.page}}
            // )
            // this.getEPDData();
        },
        // paginationChanged() {
            // this.$router.replace({
            //     query: {
            //         page: this.tableOptions.page
            //     }
            // });
        // },
    },
    mixins: [loadingMixin]
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header th {
    white-space: nowrap;
}

::v-deep .v-data-table-header__icon {
    display: inline-block;
    opacity: 100 !important;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

v-tab {
    text-transform: none;
}
</style>
